import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[dashboardTemplate-host]',
  	standalone: false
})

export class DashboardTemplateDirective {
	constructor(public viewContainerRef: ViewContainerRef ) {}
}
